import React from 'react';
import './ProductStats.css';

const ProductStats = () => (
  <section className="product-stats-section" id="product-stats-section">
    <div className="product-stats-container">
      <div className="product-stat">
        <div className="product-stat-number">100+</div>
        <div className="product-stat-label">Satisfied customers</div>
      </div>
      <div className="product-stat">
        <div className="product-stat-number">10+</div>
        <div className="product-stat-label">Legal Checks</div>
      </div>
      <div className="product-stat">
        <div className="product-stat-number">5+</div>
        <div className="product-stat-label">Immigration Advisors</div>
      </div>
    </div>
  </section>
);

export default ProductStats; 